import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import TextBlock from 'ui-component-library/components/00-Primitives/TextBlock'

import style from './style.scss'

type Props = {
  titleText: string
  bodyText: string
  errorMessage?: string
}

function ProblemWithOrder({ titleText, bodyText, errorMessage }: Props) {
  return (
    <>
      <HeadlineTwo>{titleText}</HeadlineTwo>
      <TextBlock>{bodyText}</TextBlock>
      {errorMessage && <p className={style.errorMessage}>{errorMessage}</p>}
    </>
  )
}

export default ProblemWithOrder
